import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app-store")({
	beforeLoad: () => {
		throw redirect({
			href: "https://apps.apple.com/app/apple-store/id6746954963?pt=123127751&ct=macrowave.co&mt=8",
		});
	},
});
